module.exports = __webpack_public_path__ + "icon-github@2x.png?f719a9b33a79284ce2a5d6f56687ed33";